import { useEffect } from 'react'
import { useThemeStore } from '@/store/theme-store'

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { theme, setTheme } = useThemeStore()

  // Efeito para hidratação inicial
  useEffect(() => {
    // Verifica se está no navegador
    if (typeof window !== 'undefined') {
      // Verifica a preferência do sistema
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      
      // Tenta recuperar o tema do localStorage
      const storedTheme = localStorage.getItem('theme-storage')
      const savedTheme = storedTheme ? JSON.parse(storedTheme).state.theme : (prefersDark ? 'dark' : 'light')
      
      // Define o tema inicial
      setTheme(savedTheme)

      // Aplica o tema imediatamente
      const root = window.document.documentElement
      root.classList.remove('light', 'dark')
      root.classList.add(savedTheme)
    }
  }, [])

  // Efeito para aplicar o tema quando ele mudar
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const root = window.document.documentElement
      const isDark = theme === 'dark'

      // Remove classes antigas
      root.classList.remove('light', 'dark')
      
      // Adiciona nova classe
      root.classList.add(theme)

      // Atualiza a meta tag de cor do tema
      const metaThemeColor = document.querySelector('meta[name="theme-color"]')
      if (metaThemeColor) {
        metaThemeColor.setAttribute('content', isDark ? '#020817' : '#ffffff')
      }
    }
  }, [theme])

  return children
} 